import { Font, FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';

export class AssetLoader {
    assets: Map<string, any> = new Map<string, any>()
    loadingAssets: Map<string, Promise<any>> = new Map<string, Promise<any>>()
    fontLoader: FontLoader
    objLoader: OBJLoader

    constructor() {
        this.fontLoader = new FontLoader();
        this.objLoader = new OBJLoader();
    }
    addAsset(url: string, asset: any) {
        this.assets.set(url, asset)
        let loggedObject = asset
        if (typeof asset === 'string') loggedObject = new String(asset)
        console.log('asset loaded ' + url, loggedObject)
    }
    loadText(url: string): Promise<string> {
        const loading = this.loadingAssets.get(url)
        if (loading) return loading
        const prom = new Promise<string>((resolve, reject) => {
            if (this.assets.has(url)) resolve(this.assets.get(url))
            console.log('loading text', url)
            fetch(url).then(res => res.text()).then(text => {
                this.addAsset(url, text)
                resolve(text)
            }).catch(reject)
        })
        this.loadingAssets.set(url, prom)
        return prom
    }
    loadJson(url: string): Promise<any> {
        const loading = this.loadingAssets.get(url)
        if (loading) return loading
        const prom = new Promise<any>((resolve, reject) => {
            if (this.assets.has(url)) resolve(this.assets.get(url))
            console.log('loading json', url)
            fetch(url).then(res => res.json()).then(json => {
                this.addAsset(url, json)
                resolve(json)
            }).catch(reject)
        })
        this.loadingAssets.set(url, prom)
        return prom
    }
    loadFont(url: string): Promise<Font> {
        const loading = this.loadingAssets.get(url)
        if (loading) return loading
        const prom = new Promise<Font>((resolve, reject) => {
            if (this.assets.has(url)) resolve(this.assets.get(url))
            console.log('loading font', url)
            this.fontLoader.load(url, (font) => {
                this.addAsset(url, font)
                resolve(font)
            }, undefined, reject)

        })
        this.loadingAssets.set(url, prom)
        return prom
    }
    loadImage(url: string): Promise<HTMLImageElement> {
        const loading = this.loadingAssets.get(url)
        if (loading) return loading
        const prom = new Promise<HTMLImageElement>((resolve, reject) => {
            if (this.assets.has(url)) resolve(this.assets.get(url))
            console.log('loading image', url)
            const img = new Image()
            img.onload = () => {
                this.addAsset(url, img)
                resolve(img)
            }
            img.onerror = reject
            img.src = url
        })
        this.loadingAssets.set(url, prom)
        return prom
    }
    getPreloadedAsset(url: string) {
        return this.assets.get(url)
    }

}